export default __webpack_public_path__ + "855b3fbe07a539efcbd4097aa3c9b43e.js";